<template>
  <div class="container">
    <Header title="调课审核" type="0" route="/new/Home"></Header>
    <qz-search
      :likeSearch="false"
      :label.sync="label"
      :search.sync="search"
      :searchProps.sync="searchProps"
      @getSearchValue="getSearchValue"
    ></qz-search>
    <qz-list
      ref="qzlist"
      titleProp="kcmc"
      :isMoreCheck="true"
      :listData.sync="listData"
      :listProps.sync="listProps"
      :buttonProps="buttonProps"
    >
      <template #bottom="scoped">
        <div class="qzlist-bottom">
          <div>申请人：{{ scoped.item.cjr }}</div>
          <van-button type="primary" round @click="goDetail(scoped.item)">
            审核
          </van-button>
        </div>
      </template>
    </qz-list>
  </div>
</template>

<script>
import { returnTkText, returnColor } from "@/utils/exChang";
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      label: {},
      search: {},
      xnxq_list: [],
      listData: [],
      searchData: [
        // {
        //   label: "学年学期",
        //   prop: "xnxq",
        //   options: this.xnxq_list,
        //   type: "select",
        //   required: true
        // }
      ]
    };
  },
  computed: {
    searchProps: {
      get() {
        return this.searchData;
      },
      set(val) {
        return (this.searchData = val);
      }
    },
    listProps: {
      get() {
        return [
          {
            label: "教师",
            prop: "skls",
            type: "row"
          },
          {
            label: "课堂",
            prop: "ktmc",
            type: "row"
          },
          {
            label: "创建时间",
            prop: "cjsj",
            type: "row"
          },
          {
            label: "调课原因",
            prop: "tkyy",
            type: "row"
          }
        ];
      }
    },
    buttonProps: {
      get() {
        return [
          { label: "取消", cancel: true },
          { label: "审核", func: this.goDetail }
        ];
      }
    }
  },
  created() {
    this.query();
    sessionStorage.setItem("cardType", 2);
  },
  methods: {
    returnTkText(val) {
      return returnTkText(val);
    },
    returnColor(val) {
      return returnColor(val);
    },
    goDetail(val) {
      if (val instanceof Array) {
        this.$router.push({
          name: "tkshPlsh",
          params: { route_params: JSON.stringify(val) }
        });
      } else {
        this.$router.push({
          name: "tkshDetail",
          params: { route_params: JSON.stringify(val) }
        });
      }
    },
    getData() {
      Api.getXnxq().then(res => {
        let defaultIndex = 0;
        let arr = res.data.map((item, index) => {
          if (item.isdqxq === "1") {
            defaultIndex = index;
            this.label.xnxq = item.xqmc;
            this.search.xnxq = item.xnxq01id;
          }
          return {
            text: item.xqmc,
            value: item.xnxq01id
          };
        });
        this.xnxq_list = { columns: arr, defaultIndex: defaultIndex };
        this.searchProps = [
          {
            label: "学年学期",
            prop: "xnxq",
            options: this.xnxq_list,
            type: "select",
            required: true
          }
        ];
        this.query();
      });
    },
    getSearchValue(val1, val2, val3) {
      this.search = val1;
      this.label = val2;
      this.searchProps = val3;
      this.query();
    },
    query() {
      Api.getTklist(this.search).then(res => {
        this.listData = res.data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  height: calc(~"100vh - 120px");
  overflow: auto;
  .qzlist-bottom {
    padding-top: 11.5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    margin-bottom: -2px;
    margin-top: 11.5px;
    border-top: 1px solid #e5e5e5;
    .van-button {
      width: 70px;
      height: 30px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/tksh/unpass.vue